module.exports = __webpack_public_path__ + "static/media/underline.478deb4d.svg";